export interface ITabMetrics {
    activeRequests: number;
    outgoingRequests: number;
    isOutgoingPastDueIncluded: boolean;
    incomingRequests: number;
    isIncomingPastDueIncluded: boolean;
    draftRequests: number;
}

export class TabMetrics implements ITabMetrics {
    activeRequests: number;
    outgoingRequests: number;
    isOutgoingPastDueIncluded: boolean;
    incomingRequests: number;
    isIncomingPastDueIncluded: boolean;
    draftRequests: number;

    constructor() {
        this.activeRequests = 0;
        this.outgoingRequests = 0;
        this.isOutgoingPastDueIncluded = false;
        this.incomingRequests = 0;
        this.isIncomingPastDueIncluded = false;
        this.draftRequests = 0;
    }
}